import styled from "styled-components";

const HomeSlogan = styled.h1`
  text-align: center;
  color: #000;
  font-size: 65px;
  font-weight: 600;
  max-width: 1200px;
  //font-style: italic;
  font-family: sans-serif;
  margin-top: 60px;
  text-align: center;
  line-height: 1.2;
`

export default HomeSlogan